import {
  add, compose, defaultTo, filter, isEmpty, map, pipe, prop, reduce, values,
} from 'ramda';
import { concat, of } from 'rxjs';

import { actions as bootstrapActions } from '@ezugi/bootstrap';
import { GE } from '@ezugi/constants';

import { myBetsActions } from '../../actions/myBets';

const {
  notificationActions: { notification },
  betActions,
  uiActions,
} = bootstrapActions;

const handleOperatorError = (socketMessage, _state) => {
  const { BetsList } = socketMessage;

  const validBetsList = pipe(
    defaultTo([]),
    filter((bet) => bet.status === GE.IN.BET_STATUS.APPROVED),
  )(BetsList);

  const getTotalBet = compose(
    reduce(add, 0),
    map(prop('betAmount')), // same prop for B&L and classic 1DTP
    values
  );

  return concat(
    of(
      ...(isEmpty(validBetsList)
        ? [
          betActions.bet.reset(),
          uiActions.myBets.highlight(false),
        ]
        : [
          betActions.history.pop(),
          betActions.bet.update({
            current: {},
            totalBet: getTotalBet(validBetsList),
          }),
          myBetsActions.myBets.clear(),
          myBetsActions.myBets.compute(validBetsList),
        ]),
      notification.add({ message: 'messages.bet_too_late' })
    )
  );
};

export default handleOperatorError;
